import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SelectFilter from "./client-board-select-filter";
import ColorSelector from "./color-selector";
import { defaultAssignableColors } from "@Shared/utils/utils";
import defaultState from "@Broker/@Modules/clients/board/store/board-default-state";
import { SELECTED_BOARD_FILTERS } from "@Broker/@Modules/clients/board/store/board-getters";
import { mapGetters } from "vuex";
import Badge from "@Shared/components/general/badge.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { cloneDeep, isEmpty, isEqual, pickBy, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardFilter",
  components: {
    SelectFilter,
    ColorSelector,
    Badge
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    referrers: {
      type: Array,
      required: true
    },
    agents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dropdownOpen: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [SELECTED_BOARD_FILTERS])), {}, {
    hasActiveFilters() {
      return !isEqual(this.SELECTED_BOARD_FILTERS, defaultState.defaultFilters);
    },
    referrersWithNone() {
      return [{
        id: "null",
        text: this.$t("boards.messages.noReferrer")
      }, ...this.referrers];
    },
    agentsWithNone() {
      return [{
        id: "null",
        text: this.$t("boards.messages.noAgent")
      }, ...this.agents];
    },
    collaboratorsWithNone() {
      return [{
        id: "null",
        text: this.$t("boards.messages.noCollaborator")
      }, ...this.agents];
    },
    upcomingMilestones() {
      return this.value.upcomingMilestones;
    },
    activities() {
      return this.value.activities;
    },
    selectedReferrers() {
      return this.value.referrers;
    },
    selectedAgents() {
      return this.value.agents;
    },
    selectedCollaborators() {
      return this.value.collaborators;
    },
    cardColors() {
      return values(defaultAssignableColors());
    }
  }),
  watch: {
    "value.colors"(val) {
      if (isEmpty(val)) this.$refs.colorSelector.reset();
    }
  },
  methods: {
    notifyFilterChanged(filterData) {
      this.$emit("input", _objectSpread(_objectSpread({}, this.value), filterData));
      Amplitude.logEvent("Board - filter changed", {
        data: filterData
      });
    },
    handleUpcomingChange(event, key) {
      const upcomingMilestones = pickBy(this.value.upcomingMilestones, (value, key) => key !== "all");
      upcomingMilestones[key] = event.target.checked;
      const all = isEqual(upcomingMilestones, {
        "past-due": false,
        active: false,
        upcoming: false,
        planned: false
      });
      this.notifyFilterChanged({
        upcomingMilestones: _objectSpread(_objectSpread({}, upcomingMilestones), {}, {
          all
        })
      });
    },
    handleActivitiesChange(event, key) {
      const activities = pickBy(this.value.activities, (value, key) => key !== "all");
      activities[key] = event.target.checked;
      const all = isEqual(activities, {
        "past-due": false,
        active: false,
        upcoming: false,
        planned: false
      });
      this.notifyFilterChanged({
        activities: _objectSpread(_objectSpread({}, activities), {}, {
          all
        })
      });
    },
    handleSelect2Change(data, type, selectType) {
      let items;
      let key;
      let itemToFilter = data.username;
      switch (selectType) {
        case "referrer-filter":
          items = cloneDeep(this.selectedReferrers);
          key = "referrers";
          itemToFilter = data.id;
          break;
        case "agent-filter":
          items = cloneDeep(this.selectedAgents);
          key = "agents";
          break;
        case "collab-filter":
          items = cloneDeep(this.selectedCollaborators);
          key = "collaborators";
          break;
      }
      switch (type) {
        case "select":
          items.push(itemToFilter);
          break;
        case "unselect":
          items = _filterInstanceProperty(items).call(items, collab => collab !== itemToFilter);
          break;
      }
      this.notifyFilterChanged({
        [key]: [...items]
      });
    },
    handleSelectColor(colors) {
      this.notifyFilterChanged({
        colors
      });
    },
    clearAllFilters() {
      this.$emit("reset");
      Amplitude.logEvent("Board - filter reset");
    }
  }
});